import gql from 'graphql-tag';

export const EXTRA_ACTIVITY = gql`
  query ($id: ID!) {
    activity(id: $id) {
      from
      to
      presentActivityIndicator
      activityType
      organisationName
      position
      majorResponsibilities
      volunteerMode
      supportingDocuments {
        id
        link
        name
      }
    }
  }
`;
